// Zentrale Feature-Flags.
// PREMIUM_PLUS_ENABLED: Das Medien-Hosting (Premium+) ist noch nicht implementiert
// (kein Storage-Backend). Solange es nicht lieferbar ist, darf es nirgends kaufbar
// oder beworben sein — sonst Gewährleistungs-/Irreführungsrisiko.
export const PREMIUM_PLUS_ENABLED = false
